// Configuración de datos de contacto desde variables de entorno
export const contactConfig = {
    phone: {
        display: process.env.REACT_APP_PHONE_NUMBER || '+1 (346) 213-5545',
        clean: process.env.REACT_APP_PHONE_CLEAN || '13462135545',
        tel: `tel:+${process.env.REACT_APP_PHONE_CLEAN || '13462135545'}`,
        whatsapp: `https://wa.me/${process.env.REACT_APP_PHONE_CLEAN || '13462135545'}`
    },
    email: {
        address: process.env.REACT_APP_EMAIL || 'njdesignprint@gmail.com',
        mailto: `mailto:${process.env.REACT_APP_EMAIL || 'njdesignprint@gmail.com'}`
    },
    company: {
        name: process.env.REACT_APP_COMPANY_NAME || 'NJ Design & Print',
        location: process.env.REACT_APP_LOCATION || 'Houston, Texas'
    },
    social: {
        whatsappUrl: process.env.REACT_APP_WHATSAPP_URL || 'https://api.whatsapp.com/send?phone=%2B13462135545',
        whatsappMessage: '¡Hola! Me interesa obtener información sobre sus servicios de diseño e impresión.',
        emailSubject: 'Consulta sobre servicios',
        emailBody: '¡Hola! Me interesa obtener información sobre sus servicios.'
    }
};

export default contactConfig;
